import { SizedTextDisplay } from "../../../../core/components/textDisplay/TextDisplay";
import { IComponentView } from "../../../../redux/types/ComponentView";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import CheckboxDataInput from "../../../components/checkboxDataInput/CheckboxDataInput";
import SizedDateDataInput from "../../../components/dateDataInput/DateDataInput";
import DateDisplay from "../../../components/dateDisplay/DateDisplay";
import DropdownDataInput from "../../../components/dropdownDataInput/DropdownDataInput";
import TextDataInput from "../../../components/textDataInput/TextDataInput";
import { DATE_INPUT, USAGE_ROWS_SECTION_KEY } from "../../../Consts";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IUsageRowData } from "../../../types/usageTypes/IUsageRowData";

const DEFAULT_VIEW_NAME = "Default View";
export interface IUsageRowViewProps {
    usage: IUsageRowData;
    changeUsageData: (fieldName: any, value: any) => void;
    dataGridTableData: IRepertoireComponentDataItem;
    lookupValues: any;
    getMaxWidth: (fieldName: string) => number;
    gridData?: IRepertoireField[];
}

const UsageBodyFields: React.FC<IUsageRowViewProps> = ({
    usage,
    changeUsageData,
    dataGridTableData, 
    getMaxWidth,
    lookupValues,
    gridData
}) => {


    const getRowColumns = () => {
        let updatedGridData = gridData.filter(item => item.name !== 'isSelected');
    
        const rows: JSX.Element[][] = [];
    
        let columnIndex = 0;
    
        for (let [key, dataItem] of Object.entries(usage)) {
            const section = updatedGridData.find(x => x.name === key);
            if (!section) continue;
    
            let column: JSX.Element | null = null;
            if (!dataItem?.inputType) {
            column = (
                        column = (
                        <div className="form-group col-md-2 col-sm-6 col-xs-12" key={key} id={key}>
                            {section.data && <label style={{ display: 'block', whiteSpace: 'nowrap' }}>{section.data}{':'}</label>}
                            <TextDataInput
                                changeData={changeUsageData}
                                fieldName={key}
                                value={dataItem?.value ? dataItem?.value : ''}
                                isHidden={false}
                                Width={getMaxWidth(key)}
                            />
                        </div>
                    ))
             } else {
            switch (dataItem.inputType) {
                case 'row':
                    if (key === 'usageDate' || key === 'programStartDate' || key === 'programEndDate') {
                        column = (
                            <div className="form-group col-md-2 col-sm-6 col-xs-12" key={key} id={key}>
                                <label style={{ display: 'block' }}>{section.data}</label>
                                <div style={{ minHeight: '50px' }} id="rowDate">
                                <DateDisplay value={dataItem.value} showTime={true} isUtcTime={true} isIncludeSeconds={true} />
                                </div>
                            </div>
                        );
                    } else if (key === 'dateLoaded') {
                        column = (
                            <div className="form-group col-md-2 col-sm-6 col-xs-12" key={key} id={key}>
                                <label style={{ display: 'block' }}>{section.data}</label>
                                <div style={{ minHeight: '50px' }} id="rowDate">
                                <DateDisplay value={dataItem.value} showTime={true} isUtcTime={false} isIncludeSeconds={true} />
                                </div>
                            </div>
                        );
                    } else {
                        column = (
                            <div className="form-group col-md-2 col-sm-6 col-xs-12" key={key} id={key}>
                                <label style={{ display: 'block', whiteSpace: 'nowrap' }}>{section.data}{':'}</label>
                                <div className="tableCell" id="rowText" style={{ minHeight: '50px' }}>{dataItem.value}</div>
                            </div>
                        );
                    }
                    break;
    
                case 'text':
                    column = (
                        <div className="form-group col-md-2 col-sm-6 col-xs-12" key={key} id={key}>
                            <label style={{ display: 'block', whiteSpace: 'nowrap' }}>{section.data}{':'}</label>
                            <TextDataInput
                                changeData={changeUsageData}
                                fieldName={key}
                                value={dataItem.value}
                                isHidden={false}
                                Width={getMaxWidth(key)}
                            />
                        </div>
                    );
                    break;
    
                case 'dropdown':
                    let countryLookup = lookupValues['Territory'].lookups
                        .filter(l => l.code.length === 2)
                        .map(l => ({ code: l.code, description: l.description }));
                    countryLookup.sort((a, b) => a.code.localeCompare(b.code));
                    column = (
                        <div className="form-group col-md-2 col-sm-6 col-xs-12" key={key} id={key}>
                            <label style={{ display: 'block' }}>{section.data}{':'}</label>
                            <DropdownDataInput
                                changeData={changeUsageData}
                                fieldName={key}
                                value={dataItem.value}
                                options={countryLookup}
                                allowNull={true}
                                isHidden={false}
                                useComboBoxAsMenuWidth={false}
                                showDropdownsAsCodes={true}
                            />
                        </div>
                    );
                    break;

                case 'date':
                    column = (
                        <div className="form-group col-md-2 col-sm-6 col-xs-12" key={key} id={key}>
                            <label style={{ display: 'block' }}>{section.data}{':'}</label>
                            <SizedDateDataInput
                                label={undefined}
                                changeData={changeUsageData}
                                fieldName={key as any}
                                value={dataItem.value}
                                isHidden={false}
                                showTime={true}
                            />
                        </div>
                    );
                    break;

                default:
                    column = (
                        <div className="form-group col-md-2 col-sm-6 col-xs-12" key={key} id={key}>
                            <label style={{ display: 'block', whiteSpace: 'nowrap' }}>{section.data}{':'}</label>
                            <div className="tableCell" id="rowText" style={{ minHeight: '50px' }}>{dataItem?.value ?? ''}</div>
                        </div>
                    );
                    break;
    
                case 'checkbox':
                    column = (
                        <div className="form-group col-md-2 col-sm-6 col-xs-12" key={key} id={key}>
                            <label style={{ display: 'block' }}>{section.data}</label>
                            <CheckboxDataInput
                                label=""
                                fieldName={key}
                                value={dataItem.value}
                                changeData={changeUsageData}
                                readonly={false}
                                isHidden={null}
                            />
                        </div>
                    );
                    break;
            }
        }

            if (column) {
                const rowIndex = Math.floor(columnIndex / 6);
                if (!rows[rowIndex]) {
                    rows[rowIndex] = [];
                }
                rows[rowIndex].push(column);
                columnIndex++;
            }
        }
    
    
        return rows.map((row, idx) => (
            <div className=" row" key={`row-${idx}`} id={`row-${idx}`}>
                {row}
            </div>
        ));
    };
    if (dataGridTableData && dataGridTableData.fields && usage) {

        return (
            <div className=" paddingHorizontalLarge flexColumn" id={`usage-row-body-fields`}>
                {getRowColumns()}
            </div>
        );

    } else {
        return <>Loading...</>
    }
 

}

export default UsageBodyFields;